import { FC } from 'react'
import { House, Office } from '../assets'
import SimulationButton from '../components/simulation-button/SimulationButton'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from 'store/types'
import { updateSimulationInput } from 'store/simulation/actions/updateSimulationInput'
import { nextSimulationStep } from 'store/simulation/actions/switchSimulationStep'
import NavigationButtons from '../components/navigation-buttons/NavigationButtons'
import { SimulationInputKeys } from 'store/simulation/types'
import { trackEvent } from 'utils/eventTracking'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import styles from '../components/simulation-button/SimulationButton.module.scss'
import stepStyles from './Steps.module.scss'
import { updateRegistrationInput } from 'store/registration/actions/updateRegistrationInputs'
import { InputGroupKeys, PersonalDataFieldKeys } from 'store/registration/types'

export const BuyerTypeStep: FC = () => {
  // REDUX STORE
  const { inputs } = useSelector((state: Store) => state.simulation)
  const dispatch = useDispatch()

  // i18n
  const { t } = useTranslation('simulation')

  /**
   * Handles the simulation button click
   *
   * @param hasVat
   */
  const handleSimulationButtonClick = (hasVat: boolean) => {
    // Set hasVat in simulation store
    dispatch(updateSimulationInput({ key: SimulationInputKeys.HAS_VAT, value: hasVat }))

    // Set isCompany in registration store
    dispatch(updateRegistrationInput({ group: InputGroupKeys.PERSONAL_DATA, key: PersonalDataFieldKeys.IS_COMPANY, value: hasVat }))

    // Track 'Simulation Started' event @Semetis
    trackEvent('simulation_started', {
      costumer_type: hasVat ? 'company' : 'private',
      step: 'buyer-type'
    })

    // Go to next step
    dispatch(nextSimulationStep())
  }

  return (
    <div>
      <div className="is-flex-column is-flex-centered">
        <h2 className={classNames(stepStyles.title, 'margin-top-none', 'margin-bottom-l')}>{t('vatNumberTitle', 'Ik ben...')}</h2>
      </div>

      <div className={classNames(styles['simulation-buttons'], styles['is-2'])}>
        <SimulationButton
          title={t('residence', 'Particulier')}
          icon={<House />}
          onClick={() => handleSimulationButtonClick(false)}
          highlighted={inputs.hasVat === false}
        />

        <SimulationButton
          title={t('company', 'Bedrijf')}
          icon={<Office />}
          onClick={() => handleSimulationButtonClick(true)}
          highlighted={inputs.hasVat === true}
        />
      </div>

      <NavigationButtons nextDisabled={inputs.hasVat === null} onNextClick={() => handleSimulationButtonClick(inputs.hasVat)} />
    </div>
  )
}
